import React from "react";
import { LinkedDestination, LinkedDestinationStatus } from "../../../../models/Entities";
import { snakeCaseToSentenceCase } from "../../../../services";
import {
  Badge,
  Button,
  ButtonVariant,
  Text,
  CopyTextField,
} from "@merge-api/merge-javascript-shared";
import { Trash } from "lucide-react";

type LinkedDestinationTableRowsProps = {
  linked_destinations: LinkedDestination[];
  setLinkedDestinationToDelete: (destination: LinkedDestination) => void;
};

const LinkedDestinationTableRows = ({
  linked_destinations,
  setLinkedDestinationToDelete,
}: LinkedDestinationTableRowsProps) => {
  const destinationStatus = (destination: LinkedDestination) => {
    switch (destination.status) {
      case LinkedDestinationStatus.DESTINATION_STATUS_COMPLETE:
        return <Badge color="green">{snakeCaseToSentenceCase("complete")}</Badge>;
      case LinkedDestinationStatus.DESTINATION_STATUS_RELINK_NEEDED:
        return <Badge color="red">{snakeCaseToSentenceCase("relink_needed")}</Badge>;
      default:
        return null;
    }
  };

  if (!linked_destinations || linked_destinations.length === 0) return null;

  return (
    <>
      {linked_destinations.map((linked_destination) => (
        <tr
          className="table-link cursor-default"
          key={linked_destination.id}
          style={{ borderBottomWidth: 0 }}
        >
          <td>
            {/* TODO: @ankitd make ths a real image and text display https://app.asana.com/1/1174208460831550/project/1210177236619782/task/1210238798928207?focus=true*/}
            <img src={linked_destination.destination_image} />{" "}
            <Text>{linked_destination.destination_name}</Text>
          </td>
          <td>{destinationStatus(linked_destination)}</td>
          {/* Linked destination ID is a tenant-scoped identifier and is thus masked at the cell */}
          <td className="ph-no-capture">
            <CopyTextField text={linked_destination.id} />
          </td>
          <td>
            <div className="text-right flex items-center justify-end">
              {linked_destination.status ===
                LinkedDestinationStatus.DESTINATION_STATUS_RELINK_NEEDED && (
                <Button
                  size="sm"
                  variant={ButtonVariant.TertiaryWhite}
                  className="mr-3"
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                >
                  Relink
                </Button>
              )}
              <Button
                size="sm"
                variant={ButtonVariant.IconOnly}
                onClick={(event) => {
                  event.stopPropagation();
                  setLinkedDestinationToDelete(linked_destination);
                }}
              >
                <Trash size={16} />
              </Button>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default LinkedDestinationTableRows;
